module.exports = "https://bin.bnbstatic.com/_next/static/images/exchange-001006a32b91efec9018b075523e02c9.png";